const theme = {
  // primary
  primary: '#4167B2',

  // warning text
  warning: '#E0A800',

  // secondary
  secondary_000: '#000000',
  secondary_100: '#333333',
  secondary_200: '#666666',
  secondary_300: '#AAAAAA',
  secondary_850: '#F9F9F9',
  secondary_900: '#FFFFFF',

  // box-shadow
  boxShadow: '0 0 20px 2px rgba(0,0,0,.1)',
  border: 'solid 1px rgba(0,0,0,.1)'
}

export default theme
